import { Controller } from "@hotwired/stimulus"

// Submits the form on change (debounced) so inline edits save without a click.
export default class extends Controller {
  static values = { delay: { type: Number, default: 400 } }

  connect() {
    this.element.addEventListener("change", this.schedule)
  }

  disconnect() {
    this.element.removeEventListener("change", this.schedule)
    clearTimeout(this.timer)
  }

  schedule = () => {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.submit(), this.delayValue)
  }

  submit(event) {
    if (event) event.preventDefault()
    clearTimeout(this.timer)
    this.element.requestSubmit()
  }
}
